import "./ClientFooter.css";

function ClientFooter() {
  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="info">
          <p className="copyright">
           Giấy phép phát hành trò chơi điện tử G1- 635/QĐ-PTTH&TTĐT
         </p>
           <p className="copyright">
              Giữ nguyên chất: đồ xanh + vài món HKMP không KNVC, PK mọi lúc mọi nơi, sống lại thời kỳ công thành chiến, không cày cấp. Nơi người xưa gặp lại. Trở về đúng nghĩa hai chữ thanh xuân.
           </p>
        </div>
      </div>
    </div>
  );
}

export default ClientFooter;
